import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ApplicationItem, RequestStrategyEnum } from '@shared/api';

interface IApplicationsByCustomerStore {
  loading: boolean;
  error: string | null;
  applications: ApplicationItem[];
  getApplicationsByCustomer: (customerId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationsByCustomerStore = create<IApplicationsByCustomerStore>((set) => ({
  loading: false,
  error: null,
  applications: [],

  getApplicationsByCustomer: ApiUtils.wrapperApi(async (customerId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null, applications: [] });
      const result = await ApplicationApi.getApplicationsByCustomer(customerId, signal);
      set({ applications: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ applications: [], loading: false, error: null }),
}));
